import { buildInternalErrorMessage } from '../errors/apiErrorHandler';
import { getLastCorrelationId } from '../observability/requestLogger';

export class ApiSessionTimeoutError extends Error {
  constructor() {
    super('Session timeout');
    this.name = 'ApiSessionTimeoutError';
  }
}

export class ApiResponseError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ApiResponseError';
  }
}

export function unwrapResponseModel(responseData) {
  if (responseData === 'Timeout') {
    throw new ApiSessionTimeoutError();
  }
  if (responseData?.errorMessage || responseData === 'Forbidden.') {
    throw new ApiResponseError(responseData?.errorMessage || 'Forbidden.');
  }
  return responseData?.returnModel;
}

export function unwrapPagedResponseModel(responseData) {
  const model = unwrapResponseModel(responseData);
  if (!model) {
    return { items: [], totalCount: 0, page: 1, pageSize: 10 };
  }
  if (Array.isArray(model)) {
    return {
      items: model,
      totalCount: model.length,
      page: 1,
      pageSize: model.length || 10,
    };
  }
  return {
    items: model.items ?? [],
    totalCount: model.totalCount ?? 0,
    page: model.page ?? 1,
    pageSize: model.pageSize ?? 10,
  };
}

function resolveCorrelationId(error) {
  return error?.correlationId ?? error?.data?.correlationId ?? getLastCorrelationId();
}

export function classifyApiError(error) {
  if (error instanceof ApiSessionTimeoutError || error?.status === 408) {
    return { type: 'timeout', message: '' };
  }

  if (error instanceof ApiResponseError) {
    return { type: 'functional', message: error.message, isFunctional: true };
  }

  const status = error?.status ?? 0;
  const correlationId = resolveCorrelationId(error);
  const bodyFunctionalMessage = error?.data?.errorMessage;

  if (bodyFunctionalMessage) {
    return { type: 'functional', message: bodyFunctionalMessage, isFunctional: true };
  }

  if (status === 403 || error?.data === 'Forbidden.') {
    return {
      type: 'functional',
      message: 'No tiene permisos para esta operación.',
      isFunctional: true,
    };
  }

  if (status >= 500 || status === 0) {
    return {
      type: 'internal',
      message: buildInternalErrorMessage(correlationId),
      correlationId,
      isFunctional: false,
    };
  }

  if (status >= 400 && status < 500 && error?.message) {
    return { type: 'functional', message: error.message, isFunctional: true };
  }

  return {
    type: 'internal',
    message: buildInternalErrorMessage(correlationId),
    correlationId,
    isFunctional: false,
  };
}

/** Mensaje listo para mostrar en UI (rojo). */
export function getDisplayErrorMessage(error, classify = classifyApiError) {
  const outcome = classify(error);
  return outcome.message || '';
}
